import React from 'react';

export default function ContactPage() {
  const contactInfo = [
    { 
      icon: 'ri-building-line', 
      title: 'Company Name', 
      content: 'Saar Developers Code Private Limited',
      sub: 'Parent Organization'
    },
    { 
      icon: 'ri-mail-send-line', 
      title: 'Email Support', 
      content: 'support@zotrai.com',
      sub: '24/7 Response Time'
    },
    { 
      icon: 'ri-phone-line', 
      title: 'Phone Number', 
      content: '+91-7207642485',
      sub: 'Mon-Sat, 10am - 7pm'
    },
    { 
      icon: 'ri-map-pin-2-line', 
      title: 'Office Location', 
      content: 'Hyderabad, India',
      sub: 'Global Tech Hub'
    },
  ];

  return (
    <div style={{ backgroundColor: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
      {/* --- MINIMALIST HERO --- */}
      <section className="py-2" style={{ 
        background: 'radial-gradient(at top left, #f1f5f9 0%, #ffffff 50%)',
        paddingTop: '80px !important'
      }}>
        <div className="container text-center">
            <span className="badge rounded-pill mb-3 px-3 py-2" style={{ backgroundColor: '#eef4ff', color: '#0d6efd', fontWeight: '700', letterSpacing: '1px' }}>
                GET IN TOUCH
            </span>
            <h1 className="display-4 fw-bold mb-4" style={{ letterSpacing: '-2px', color: '#0f172a' }}>
                Let’s Scale Your <span style={{ color: '#0d6efd' }}>Travel Business.</span>
            </h1>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
                Reach out to the team at <span className="fw-bold text-dark">Zotrai</span> by <span className="fw-bold text-dark">Saar Developers</span> for support, demos, or partnerships.
            </p>
        </div>
      </section>

      {/* --- MAIN CONTACT SECTION --- */}
      <section className="py-1 mb-5">
        <div className="container">
          <div className="row g-5 align-items-start">
            
            {/* Left Side: Info Cards */}
            <div className="col-lg-5">
                <div className="row g-3">
                    {contactInfo.map((item, index) => (
                        <div className="col-12" key={index}>
                            <div className="p-4 border rounded-5 transition-hover d-flex align-items-center bg-white shadow-sm">
                                <div className="icon-box-small me-4">
                                    <i className={`${item.icon} fs-3`}></i>
                                </div>
                                <div>
                                    <h6 className="text-muted small fw-bold text-uppercase mb-1" style={{ letterSpacing: '1px' }}>{item.title}</h6>
                                    <h5 className="fw-bold text-dark mb-0">{item.content}</h5>
                                    <p className="small text-muted mb-0">{item.sub}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Side: Modern Form */}
            <div className="col-lg-7">
              <div className="card border-0 shadow-lg p-lg-5 p-4 rounded-5" style={{ backgroundColor: '#f8fafc' }}>
                <h3 className="fw-bold mb-4">Send a Message</h3>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6 mb-3">
                      <label className="form-label small fw-bold text-secondary">FULL NAME</label>
                      <input type="text" className="form-control form-control-lg border-0 shadow-sm rounded-4 px-4 py-3" placeholder="Enter your name" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label small fw-bold text-secondary">EMAIL ADDRESS</label>
                      <input type="email" className="form-control form-control-lg border-0 shadow-sm rounded-4 px-4 py-3" placeholder="name@company.com" />
                    </div>
                    <div className="col-12 mb-4">
                      <label className="form-label small fw-bold text-secondary">YOUR MESSAGE</label>
                      <textarea className="form-control border-0 shadow-sm rounded-4 px-4 py-3" rows="5" placeholder="How can we help your agency grow?"></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary btn-lg w-100 rounded-pill fw-bold py-3 shadow-lg transition-all">
                        Send Message <i className="ri-send-plane-fill ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      <style dangerouslySetInnerHTML={{ __html: `
        .rounded-5 { border-radius: 2rem !important; }
        
        .icon-box-small {
            width: 60px;
            height: 60px;
            background: #f0f7ff;
            color: #0d6efd;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
        }

        .transition-hover {
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            border-color: #f1f5f9 !important;
        }

        .transition-hover:hover {
            transform: translateY(-5px);
            border-color: #0d6efd !important;
            box-shadow: 0 15px 30px rgba(13, 110, 253, 0.08) !important;
            background-color: #fcfdff !important;
        }

        .transition-hover:hover .icon-box-small {
            background: #0d6efd;
            color: #ffffff;
            transform: rotate(5deg) scale(1.05);
        }

        .form-control:focus {
            box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1) !important;
            background-color: #ffffff !important;
        }

        .transition-all { transition: all 0.3s ease-in-out; }
      `}} />
    </div>
  );
}